import { InternalStatusCodes } from "../entities/formEvent";

export function mapStatusCodeToStatusText(
    statusCode?: InternalStatusCodes
): string {
    switch (statusCode) {
        case InternalStatusCodes.UnknownError:
            return "Fejl";
        case InternalStatusCodes.FormReceived:
            return "Del A af attesten er modtaget fra blanketmotor";
        case InternalStatusCodes.ReceiptSend:
            return "Kvittering for Del A er afsendt til borger";
        case InternalStatusCodes.ReceiptReceivedAck:
            return "Kvittering for Del A er modtaget af borger";
        case InternalStatusCodes.ReceiptBSend:
            return "Kvittering for færdigudfyldt lægeattest er afsendt til borger";
        case InternalStatusCodes.ReceiptBReceivedAck:
            return "Kvittering for færdigudfyldt lægeattest er modtaget af borger";
        case InternalStatusCodes.CaseCreated:
            return "Attesten er oprettet i løsningen";
        case InternalStatusCodes.WaitingDoctor:
            return "Venter på svar fra læge";
        case InternalStatusCodes.ReceivedByDoctor:
            return "Del A af attesten er hentet af lægesystemet";
        case InternalStatusCodes.DeclinedByDoctor:
            return "Afvist af læge";
        case InternalStatusCodes.ResponseByDoctor:
            return "Løsningen har modtaget attesten fra lægen";
        case InternalStatusCodes.ReceiptSendToFstyr:
            return "Kvittering for Del A er afsendt til Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptBSendToFstyr:
            return "Kvittering for færdigudfyldt lægeattest er afsendt til Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptReceivedByFstyrAck:
            return "Kvittering for Del A er modtaget af Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptBReceivedByFstyrAck:
            return "Kvittering for færdigudfyldt lægeattest er modtaget af Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptNoDoctorSend:
            return "Information for ingen læge er afsendt til borger";
        case InternalStatusCodes.ReceiptNoDoctorReceivedAck:
            return "Information for ingen læge er modtaget af borger";
        case InternalStatusCodes.ReceiptNoDoctorSendToFstyr:
            return "Information for ingen læge er afsendt til Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptNoDoctorReceivedByFstyrAck:
            return "Information for ingen læge er modtaget af Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptSsnGroup2Send:
            return "Information for sygesikringsgruppe 2 er afsendt til borger";
        case InternalStatusCodes.ReceiptSsnGroup2ReceivedAck:
            return "Information for sygesikringsgruppe 2 er modtaget af borger";
        case InternalStatusCodes.ReceiptSsnGroup2SendToFstyr:
            return "Information for sygesikringsgruppe 2 er afsendt til Færdselsstyrelsen";
        case InternalStatusCodes.ReceiptSsnGroup2ReceivedByFstyrAck:
            return "Information for sygesikringsgruppe 2 er modtaget af Færdselsstyrelsen";
        case InternalStatusCodes.Deleted:
            return "Slettet";
        default:
            return `Ukendt Status (${statusCode})`;
    }
}
